import { AuthArtPanel } from '@/components/auth/AuthArtPanel.jsx'
import { cn } from '@/lib/utils'
import Logo from '@/assets/logos/upspring-dark.png'

// Shared two-column shell for every auth / onboarding screen.
// Left: content / form / step on white paper. Right: dark art panel whose
// content changes per page / step. The art panel is hidden on small screens,
// where the left column takes the full width.
//
// Props:
//   slide      - art-panel content (see AuthArtPanel)
//   topRight   - node in the top bar right (e.g. "Create account" / "Skip")
//   topLeft    - overrides the default logo
//   footer     - node pinned to the bottom of the left column (legal / logout)
//   progress   - node rendered as a thin band above the top bar (step meter)
//   maxWidth   - content column max width (default 420)
//   hideArt    - render a single full-width column with no art panel

export function SplitAuthLayout({ children, slide, topRight, topLeft, footer, progress, maxWidth = 420, hideArt = false, align = 'center', payload = 'auto' }) {

    return (
        <div className={cn('grid min-h-screen w-full grid-cols-1 bg-auth-paper text-auth-ink', !hideArt && 'min-[900px]:grid-cols-[min(50%,800px)_1fr]')}>

            <div className="relative flex min-h-screen flex-col px-6 py-8 sm:px-10 lg:px-16">
                {progress && (
                    <div className="mb-6">
                        {progress}
                    </div>
                )}

                <div className="flex items-center justify-between">
                    <div>
                        {topLeft || <img src={Logo} alt="Upspring" className="h-6 w-auto" />}
                    </div>
                    {topRight && (
                        <div>
                            {topRight}
                        </div>
                    )}
                </div>

                <div className={cn('flex flex-1 justify-center', align === 'top' ? 'items-start pt-16' : 'items-center py-10')}>
                    <div className="w-full" style={{ maxWidth: `${maxWidth}px` }}>
                        {children}
                    </div>
                </div>

                {footer && (
                    <div className="flex justify-center">
                        {footer}
                    </div>
                )}
            </div>

            {!hideArt && (
                <div className="hidden min-[900px]:block">
                    <AuthArtPanel slide={slide} payload={payload} />
                </div>
            )}
        </div>
    )
}
